import { useMemo } from 'react';
import {
  GetSmartSuggestionSettingsDocument,
  GetSmartSuggestionSettingsQuery,
  GetSmartSuggestionSettingsQueryVariables
} from 'graphql/types';
import usePersistedCacheQuery from 'modules/common/hooks/usePersistedCacheQuery';

export const useSmartSuggestionSetting = (): {
  data: GetSmartSuggestionSettingsQuery | undefined;
  loading: boolean;
} => {
  const { loading, data } = usePersistedCacheQuery<
    GetSmartSuggestionSettingsQuery,
    GetSmartSuggestionSettingsQueryVariables
  >(GetSmartSuggestionSettingsDocument, {});

  return useMemo(
    () => ({
      loading,
      data
    }),
    [data, loading]
  );
};
